// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Blog ───────────────────────────────────────────────── */
.blog-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg-surface);
}
@media (max-width: 768px) {
  .blog-section {
    padding: 60px 5%;
  }
}

.blog-header {
  text-align: center;
  margin-bottom: 56px;
}
.blog-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
  color: var(--text) !important;
}

.blog-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.blog-description {
  color: var(--text-muted) !important;
  font-size: 0.95rem;
  line-height: 1.7;
  max-width: 600px;
  margin: 0 auto;
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 48px;
}

.blog-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
}
.blog-card:hover {
  border-color: var(--accent);
  transform: translateY(-3px);
  box-shadow: var(--shadow);
}

.blog-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.blog-card-reading-time {
  font-size: 0.72rem;
  font-weight: 600;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  color: var(--text-muted) !important;
}

.blog-card-tag {
  font-size: 0.72rem;
  font-weight: 700;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--accent-2) !important;
}

.blog-card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text) !important;
  margin: 0;
  line-height: 1.4;
}

.blog-card-excerpt {
  font-size: 0.875rem;
  color: var(--text-muted) !important;
  line-height: 1.6;
  margin: 0;
  flex-grow: 1;
}

.blog-card-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.825rem;
  font-weight: 600;
  color: var(--accent) !important;
  margin-top: 4px;
  transition: gap 0.2s;
}
.blog-card-link::after {
  content: "→";
}
.blog-card-link:hover {
  opacity: 1;
  gap: 7px;
}

@media (max-width: 700px) {
  .blog-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/blog.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;AAGF;;AAAA;EACE,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8DAAA;AAGF;AADE;EACE,2BAAA;EACA,2BAAA;EACA,yBAAA;AAGJ;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,mCAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,oBAAA;AAEF;AAAE;EAAW,YAAA;AAGb;AADE;EACE,UAAA;EACA,QAAA;AAGJ;;AACA;EACE;IAAa,0BAAA;EAGb;AACF","sourcesContent":["/* ─── Blog ───────────────────────────────────────────────── */\n\n.blog-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg-surface);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.blog-header {\n  text-align: center;\n  margin-bottom: 56px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n    color: var(--text) !important;\n  }\n}\n\n.blog-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto 20px;\n}\n\n.blog-description {\n  color: var(--text-muted) !important;\n  font-size: 0.95rem;\n  line-height: 1.7;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-top: 48px;\n}\n\n.blog-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    border-color: var(--accent);\n    transform: translateY(-3px);\n    box-shadow: var(--shadow);\n  }\n}\n\n.blog-card-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.blog-card-reading-time {\n  font-size: 0.72rem;\n  font-weight: 600;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  color: var(--text-muted) !important;\n}\n\n.blog-card-tag {\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--accent-2) !important;\n}\n\n.blog-card-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--text) !important;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.blog-card-excerpt {\n  font-size: 0.875rem;\n  color: var(--text-muted) !important;\n  line-height: 1.6;\n  margin: 0;\n  flex-grow: 1;\n}\n\n.blog-card-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.825rem;\n  font-weight: 600;\n  color: var(--accent) !important;\n  margin-top: 4px;\n  transition: gap 0.2s;\n\n  &::after { content: \"→\"; }\n\n  &:hover {\n    opacity: 1;\n    gap: 7px;\n  }\n}\n\n@media (max-width: 700px) {\n  .blog-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
